/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import {declareEntity} from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';
import {OrganisationRole, ROLE_MANAGER} from './Organisation2UserType';

export default declareEntity({
    entity: "invitations",
    graphQL: "Invitation",
    name: "Invitations",
    createPermission: [
        Permission.PERM_EDIT_INVITATION
    ],
    deletePermission: [
        Permission.PERM_EDIT_INVITATION
    ],
    updatePermission: [
        Permission.PERM_NOBODY_HAS_THAT_PERMISSION
    ],
    dynamoPrefix: 'org',
    storageType: 'central',
    parentRelation: "invitations",
    fields: (types) => { return {
        id: {
            name: "Invitation ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (organisation) => {
                return organisation['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
            hiddenCreate: true,
            defaultValue: (parent) => {
                if (parent) {
                    return parent['instance_id'];
                }
            },
        },
        secret: {
            name: "Secret",
            type: "string",
            userVisible: false,
            userEditable: false,
            defaultValue: () => {
                return uuidv4();
            },
        },
        role: {
            name: "Role",
            type: "enum",
            defaultValue: ROLE_MANAGER,
            values: OrganisationRole,
        },
        permissions: {
            name: "Permissions in organisation",
            type: "object",
            defaultValue: {},
            userEditable: false,
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        email: {
            name: "E-mail",
            type: "email",
            filterable: true,
            required: true,
            defaultValue: "",
            validations: {
                isEmail: true
            },
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
    }; }
});
